import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {doc, getDoc} from 'firebase/firestore';
import { Button } from '@mui/material';
import { CiSquarePlus } from 'react-icons/ci';
import { db } from"../../../components/Firebase/Firebase";
import { useLoading } from "../../../components/context/LoadingContext";
import DistanceList from './DistanceList'; // создадим

const DistancesPage = () => {
    const { eventId } = useParams();
    const navigate = useNavigate();
    const [distances, setDistances] = useState([]);
    const [isLoading, setIsLoading] = useLoading(false);

    useEffect(() => {
        fetchDistances();
    }, [eventId]);

    const fetchDistances = async () => {
        setIsLoading(true);
        try {
            const docRef = doc(db, 'events', eventId);
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                const data = docSnap.data();
                const distanceList = data.distances || [];
                setDistances(distanceList);
            } else {
                console.error("Документ события не найден");
                setDistances([]);
            }
        } catch (error) {
            console.error("Ошибка при загрузке дистанций:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleCreateDistance = () => {
        navigate(`/events/${eventId}/distances/new`);
    };

    return (
        <div className='right-content'>
            <div className='card shadow border-0'>
                <div className="row d-flex align-items-center w-100">
                    <div className="col">
                        <h2 className='hd'>Дистанции события {eventId}</h2>
                    </div>
                    <div className="col d-flex justify-content-end">
                        <Button
                            className="newObject"
                            onClick={handleCreateDistance}
                        >
                            <CiSquarePlus />
                        </Button>
                    </div>
                </div>
                <div className='table-responsive mt-3'>
                    <DistanceList
                        distances={distances}
                        onDistancesUpdated={fetchDistances}
                        eventId={eventId}
                    />
                </div>
            </div>
        </div>
    );
};

export default DistancesPage;
